import { Box, Typography } from '@mui/material';
import menu from '../../../../../data/menu.json';
import images from '../../../../../data/images.json';
import MenuCategory from './MenuCategory';

export default function MenuPage(){
    return(
    <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
    >
        <img src={images.banner.menu.src} alt={images.banner.menu.alt} style={{
            height:"200px",
            width:'auto',
            marginTop:3}}
        />
        
        {menu.categories.map((category)=>(
            <MenuCategory category={category} />
        ))}
        {(menu?.appendice)&&
        <Box
            sx={{
                textAlign:'left',
                width:1000,
            }}
        >
            <Typography sx={{m:1}}>
                {menu.appendice}
            </Typography>
        </Box>}
    </Box>);
}